import { PortabilityService } from 'services/portability/PortabilityService';
import { CreatedLeadDto, PortabilityControllerApi, PortabilityDto, UpdatedLeadDto } from 'client';
import { PORTABILITY_FORM_DATA_KEY_STORAGE } from 'constants/FormConstants';
import { StorageService } from 'services/storage-service/StorageService';
import { StorageServiceImpl } from 'services/storage-service/StorageServiceImpl';
import { AxiosResponse } from 'axios';

class PortabilityServiceImpl implements PortabilityService {
	private storageService: StorageService;
	private portabilityController: PortabilityControllerApi;
	constructor() {
		this.storageService = new StorageServiceImpl();
		this.portabilityController = new PortabilityControllerApi();
	}

	async CreatePortabilityData(
		token: string,
		portabilityDto: PortabilityDto
	): Promise<AxiosResponse<CreatedLeadDto>> {
		return this.portabilityController.createPortabilityLeadUsingPOST(token, portabilityDto);
	}

	async UpdatePortabilityData(
		token: string,
		id: number,
		portabilityDto: PortabilityDto
	): Promise<AxiosResponse<UpdatedLeadDto>> {
		return this.portabilityController.updatePortabilityLeadUsingPATCH(token, id, portabilityDto);
	}

	SetDataOnStorage(portabilityDto: PortabilityDto): boolean {
		return this.storageService.setToStoreObject(
			PORTABILITY_FORM_DATA_KEY_STORAGE,
			portabilityDto,
			sessionStorage
		);
	}

	DeleteIdOnStorage(): boolean {
		return this.storageService.deleteItemOnStoreObject(
			PORTABILITY_FORM_DATA_KEY_STORAGE,
			'record',
			sessionStorage
		);
	}
}
export { PortabilityServiceImpl };
